import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

import { AbstractDialogComponent } from '@Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '@Core/Dialogs/services/dialog.service';
import { FullProfileAnimationModel } from '@Core/Dialogs/models/full-profile-animation.model';
import { SplitHeader } from '@Common/TakeOver/components/TakeOverPanel/take-over-panel.component';
import { CanvasProgressState, CanvasProgressStep } from '@Monitor/Briefings/models/canvas-v2-progress.model';
import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-briefing-natural-language-loading-dialog',
    templateUrl: './briefing-natural-language-loading-dialog.component.html',
    styleUrls: ['./briefing-natural-language-loading-dialog.component.scss'],
    standalone: false
})
export class BriefingNaturalLanguageLoadingDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy {
    @Input() progressState: Observable<CanvasProgressState>;
    @Input() overlayContainer: Element;
    @Input() protected animationTrigger: BehaviorSubject<FullProfileAnimationModel>;

    readonly panelHeader: SplitHeader = {
        icon: 'fa-kit-duotone fa-agpr-ai-generic',
        initialText: '',
        value: 'Briefings.newBriefing.naturalLanguage.loadingDialog.title',
        endText: '',
        loading: false
    };

    steps: CanvasProgressStep[] = [];

    readonly messageSeverityEnum = messageSeverityEnum;
    readonly buttonTypes = ButtonTypesEnum;

    private subscription: Subscription | null = null;

    constructor(public coreDialogService: CoreDialogService) {
        super(coreDialogService, 'BriefingNaturalLanguageLoadingDialog');
    }

    ngOnInit(): void {
        this.subscription = this.progressState.subscribe(state => {
            this.steps = state.steps;
        });
    }

    handleVisibleChange(isVisible: boolean): void {
        if (!isVisible) {
            this.closeDialog();
        }
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
}
